export default "__VITE_ASSET__BRqMRjqE__"